export default __webpack_public_path__ + "static/media/Resume-Matthew-Damron.5c56c058.pdf";